import { render, staticRenderFns } from "./UpdateFees.vue?vue&type=template&id=10a0bdc1&"
import script from "./UpdateFees.vue?vue&type=script&lang=js&"
export * from "./UpdateFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports